import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { DesignSystemModule } from '@libraries/design-system';
import { FaIconModule } from '@libraries/fa';
import { UiModule } from '@libraries/ui';
import { UiStateModule } from '@libraries/ui-state';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AddButtonComponent } from './add-button/add-button.component';
import { DialogComponent } from './dialog/dialog.component';
import { FooterDesktopComponent } from './footer-desktop/footer-desktop.component';
import { GenericPageComponent } from './generic-page/generic-page.component';
import { GenericSuccessPageComponent } from './generic-success-page/generic-success-page.component';
import { GlobalMessageComponent } from './global-message/global-message.component';
import { ItemWidgetExpandableComponent } from './item-widget-expandable/item-widget-expandable.component';
import { ItemWidgetComponent } from './item-widget/item-widget.component';
import { LottieAnimationComponent } from './lottie-animation/lottie-animation.component';
import { MobileTitleImageComponent } from './mobile-title-image/mobile-title-image.component';
import { MultipleAddressComponent } from './multiple-address/multiple-address.component';
import { PageDescriptionComponent } from './page-description/page-description.component';
import { PageFooterComponent } from './page-footer/page-footer.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { SectionEditComponent } from './section-edit/section-edit.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { SelectBubblesComponent } from './select-bubbles/select-bubbles.component';
import { StageDropdownComponent } from './stage-dropdown/stage-dropdown.component';
import { WholeViewPictureComponent } from './whole-view-picture/whole-view-picture.component';

@NgModule({
  imports: [
    CommonModule,
    A11yModule,
    DesignSystemModule,
    FaIconModule,
    MatButtonModule,
    MatChipsModule,
    MatProgressBarModule,
    MatRadioModule,
    MatRippleModule,
    MatDialogModule,
    MatTooltipModule,
    RouterModule,
    ScrollingModule,
    ScrollToModule.forRoot(),
    UiModule,
    UiStateModule,
    TranslocoModule,
  ],
  declarations: [
    AddButtonComponent,
    FooterDesktopComponent,
    ItemWidgetComponent,
    LottieAnimationComponent,
    MobileTitleImageComponent,
    MultipleAddressComponent,
    PageDescriptionComponent,
    PageFooterComponent,
    PageHeaderComponent,
    ProgressBarComponent,
    SectionHeaderComponent,
    StageDropdownComponent,
    WholeViewPictureComponent,
    SectionEditComponent,
    DialogComponent,
    GlobalMessageComponent,
    ItemWidgetExpandableComponent,
    GenericSuccessPageComponent,
    GenericPageComponent,
    SelectBubblesComponent,
  ],
  exports: [
    AddButtonComponent,
    DesignSystemModule,
    FooterDesktopComponent,
    ItemWidgetComponent,
    LottieAnimationComponent,
    MobileTitleImageComponent,
    MultipleAddressComponent,
    PageDescriptionComponent,
    PageFooterComponent,
    PageHeaderComponent,
    ProgressBarComponent,
    SectionHeaderComponent,
    StageDropdownComponent,
    WholeViewPictureComponent,
    SectionEditComponent,
    ItemWidgetExpandableComponent,
    GenericSuccessPageComponent,
    GenericPageComponent,
    SelectBubblesComponent,
  ],
})
export class ComponentLibraryModule {}
